import { TFunction } from 'i18next'
import TlsRestService from '../rest/TlsRestService'
import { saveAs } from 'file-saver'


class TlsService {
  static async getCertificates(setCertificates: Function) {
    const certificates = await TlsRestService.get()
    setCertificates(certificates)
  }

  static async getTlsKeys(setkeys: Function) {
    if (setkeys) {
      const keys = await TlsRestService.getTlsKeys()
      setkeys(keys)
    } else {
      return await TlsRestService.getTlsKeys()
    }
  }

  static async getTlsKeysWithCerts(setkeys: Function) {
    if (setkeys) {
      const keys = await TlsRestService.getTlsKeysWithCerts()
      setkeys(keys)
    } else {
      return await TlsRestService.getTlsKeysWithCerts()
    }
  }

  static async download(id: number) {
    try {
      const certificate: Blob = await TlsRestService.download(id)
      saveAs(certificate, 'certificate.crt')
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async importCert(certificateInfo: any, setCertificates: Function, t: TFunction) {
    try {
      const formData = new FormData()
      formData.append('certificate', certificateInfo.certificate)
      await TlsRestService.importCert(formData)
      await TlsService.getCertificates(setCertificates)
      return t('certificates.importSuccess')
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async deleteCertificate(id: number, setCertificates: Function, t: TFunction) {
    try {
      await TlsRestService.delete(id)
      const certificates = await TlsRestService.get()
      setCertificates(certificates)
      return t('certificates.deleteSuccess')
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async getKeystoreAliases(keyStoreInfo: any) {
    try {
      const formData = new FormData()
      formData.append('keystore', keyStoreInfo.keystore)
      formData.append('keyStorePassword', keyStoreInfo.keyStorePassword)
      const keystoreAliases = await TlsRestService.getKeystoreAliases(formData)
      return { keystoreAliases, ...keyStoreInfo }
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async importKeystore(keyStoreInfo: any, keystore: any, setKeys: Function, t: TFunction) {
    try {
      const formData = new FormData()
      formData.append('name', keyStoreInfo.name)
      formData.append('alias', keyStoreInfo.alias)
      if (keystore.keystoreAliases[keyStoreInfo.alias] === 'DIFFERENT_PASSWORD') {
        formData.append('keyPassword', keyStoreInfo.keyPassword)
      } else if (keystore.keystoreAliases[keyStoreInfo.alias] === 'SAME_PASSWORD') {
        formData.append('keyPassword', keystore.keyStorePassword)
      } else {
        formData.append('keyPassword', '')
      }
      formData.append('keyStorePassword', keystore.keyStorePassword)
      formData.append('keystore', keystore.keystore)
      await TlsRestService.importKeystore(formData)
      await TlsService.getTlsKeys(setKeys)
      return t('keys.importKeystoreSuccess')
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async deleteTlsKey(keyId: string, version: number, setKeys: Function, t: TFunction) {
    try {
      await TlsRestService.deleteTlsKey(keyId, version)
      await TlsService.getTlsKeys(setKeys)
      return t('keys.deleteTlsKeySuccess')
    } catch (error) {
      return Promise.reject(error)
    }
  }
}

export default TlsService
